import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withNamespaces } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Row, Col } from 'reactstrap'
import styled from 'styled-components'

import Preloader from '../../../components/UI/Preloader'

import {
  initializeTransactions,
  fetchTransactions,
  fetchTransactionDetail
} from '../../../ducks/transactions'
import TransactionModal from '../../Dashboard/TransactionModal'
import TransactionsTable from '../../Dashboard/TransactionsTable'

const Wrapper = styled.div`
  margin-top: 34px;
  background-color: #fff;
  padding: 20px;
`

const StyledTitle = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-size: 23px;
  color: #2e384d;
  font-weight: 600;

  margin-bottom: 10px;
`

class TransactionsPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isModalOpen: false,
      containerHeight: 500
    }

    this.containerRef = React.createRef()
    window.addEventListener('resize', this.onWindowResize)
  }

  componentDidMount() {
    const { propertyId, productId } = this.props.match.params
    if (!propertyId || !productId) {
      return this.props.history.push('/dashboard/contracts')
    }
    this.props.initializeTransactions({ propertyId, productId })
    this.onWindowResize()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize)
  }

  onWindowResize = () => {
    const { innerHeight } = window
    const { top } = this.containerRef.current.getBoundingClientRect()
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const resultTop = top + scrollTop
    const resultHeight =
      innerHeight - resultTop < 500 ? 500 : innerHeight - resultTop

    this.setState({
      containerHeight: resultHeight
    })
  }

  render() {
    const { isModalOpen, containerHeight } = this.state
    const { t } = this.props
    const { loading } = this.props.transactions

    return (
      <Wrapper>
        {loading && <Preloader />}
        <TransactionModal toggleModal={this.toggleModal} isOpen={isModalOpen} />
        <Row>
          <Col xs={12}>
            <Link to="/dashboard/contracts">{t('common:goBack')}</Link>
            <StyledTitle>{t('transactions:name')}</StyledTitle>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div ref={this.containerRef}>
              <TransactionsTable
                height={containerHeight}
                toggleModal={this.toggleModal}
              />
            </div>
          </Col>
        </Row>
      </Wrapper>
    )
  }

  toggleModal = () => {
    this.setState(({ isModalOpen }) => ({ isModalOpen: !isModalOpen }))
  }
}

export default compose(
  connect(
    ({ transactions }) => ({ transactions }),
    { initializeTransactions, fetchTransactions, fetchTransactionDetail }
  ),
  withNamespaces()
)(TransactionsPage)
